export default "__VITE_ASSET__CI25NKS5__"